export default __webpack_public_path__ + "static/media/entity-mention-typing.eaa2cb46.gif";